import React, { ReactElement } from 'react';
import { Theme, Container, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import AlmeThemeModeToggle from '../AlmeThemeModeToggle/AlmeThemeModeToggle';
import AlmeThemeSelector from '../AlmeThemeSelector/AlmeThemeSelector';
import AlmePaletteTool from './AlmePaletteTool/AlmePaletteTool';
import AlmeThemeTool from './AlmeThemeTool/AlmeThemeTool';
import AlmeAppConfigTool from '../AlmeApp/AlmeAppConfigTool';
import AlmeIconColorTool from '../AlmeIconColorTool/AlmeIconColorTool';
import { AlmeTheme, AlmeThemeMode } from '../../models/AlmeTheme';
import { AlmeConfig } from '../../models/AlmeConfig';

const useStyles = makeStyles(({ palette, spacing }: Theme) =>
    createStyles({
        root: {
            border: `solid 1px ${palette.divider}`,
            padding: spacing(1),
        },
    }),
);

interface AlmeStyleToolsProps {
    theme: AlmeTheme;
    themeMode: AlmeThemeMode;
    almeConfig: AlmeConfig;
    setTheme: (theme: AlmeTheme) => void;
    setThemeMode: (themeMode: AlmeThemeMode) => void;
    setConfig: (config: AlmeConfig) => void;
}

export default function AlmeStyleTools(props: AlmeStyleToolsProps): ReactElement {
    const classes = useStyles();

    return (
        <Container className={classes.root}>
            <Typography variant='subtitle1'>Style Tools</Typography>
            <AlmeThemeModeToggle setThemeMode={props.setThemeMode} themeMode={props.themeMode} almeConfig={props.almeConfig} />
            <br />
            <AlmeThemeSelector setTheme={props.setTheme} />
            <br />
            <AlmePaletteTool setTheme={props.setTheme} theme={props.theme} themeMode={props.themeMode} />
            <br />
            <AlmeThemeTool setTheme={props.setTheme} theme={props.theme} themeMode={props.themeMode} />
            <br />
            <AlmeAppConfigTool setConfigState={props.setConfig} almeConfig={props.almeConfig} />
            <br />
            <AlmeIconColorTool almeConfig={props.almeConfig} />
        </Container>
    );
}